import ToolTip from 'components/tooltip/ToolTip';
import React, { FC } from 'react';
import { Check, FileText, Play } from '@phosphor-icons/react';
import 'twin.macro';
import { safeDecodeURI } from 'utils/fileHelpers';
import * as Styles from './ResourcePickerStyles';

import {
  TypedCustomerResource,
  isResourceEnabledFn,
  isResourceSelectedFn,
  selectHandlerFn,
} from './ResourceTypes';

type ResourceItemProps = {
  resource: TypedCustomerResource;
  invalidResources: number[];
  onSelectHandler: selectHandlerFn;
  isResourceEnabled: isResourceEnabledFn;
  isResourceSelected: isResourceSelectedFn;
};

const ResourceItem: FC<ResourceItemProps> = (props) => {
  const {
    resource,
    invalidResources,
    isResourceEnabled,
    isResourceSelected,
    onSelectHandler,
  } = props;
  return (
    <ToolTip
      text={safeDecodeURI(resource.name)}
      key={resource.id}
      wordBreak={'break-all'}
      arrow
    >
      <Styles.ResourceListItem>
        <Styles.SelectableResource
          resourceType={resource.type}
          disabled={
            !isResourceEnabled(resource) ||
            invalidResources.includes(resource.id)
          }
          onClick={(e) => onSelectHandler(e, resource)}
        >
          {isResourceSelected(resource) && (
            <div tw="absolute top-2 left-2 p-1 rounded-full bg-indigo-500 z-20">
              <Check weight="bold" tw="text-indigo-200" size="18" />
            </div>
          )}
          {resource.type === 'image' || resource.type === 'logo' ? (
            <Styles.Img
              src={resource.path}
              crossOrigin="anonymous"
              loading="lazy"
              alt={safeDecodeURI(resource.name)}
              className="resource-image"
              selected={isResourceSelected(resource)}
              isDisabled={!isResourceEnabled(resource)}
            />
          ) : resource.type === 'video' ? (
            <div
              className="group"
              tw="relative w-full h-full bg-gray-100 overflow-hidden"
            >
              <div tw="absolute inset-0 flex items-center justify-center">
                <div tw="w-12 h-12 rounded-full bg-black/50 flex items-center justify-center">
                  <Play weight="fill" tw="text-white" size={24} />
                </div>
              </div>
              <Styles.Img
                src={resource.thumbnail_path}
                loading="lazy"
                alt={safeDecodeURI(resource.name)}
                className="resource-image"
                selected={isResourceSelected(resource)}
                isDisabled={!isResourceEnabled(resource)}
              />
            </div>
          ) : resource.type === 'avatar' ? (
            <Styles.Img
              src={resource.thumbnail_path || resource.path}
              loading="lazy"
              alt={safeDecodeURI(resource.name)}
              className="resource-image"
              selected={isResourceSelected(resource)}
              isDisabled={!isResourceEnabled(resource)}
            />
          ) : resource.type === 'document' ? (
            <Styles.MediaResource
              selected={isResourceSelected(resource)}
              isDisabled={!isResourceEnabled(resource)}
            >
              <FileText weight="bold" tw="text-gray-500" size={20} />{' '}
              <span
                tw="text-sm text-gray-700 truncate"
                style={{ maxWidth: 74 }}
              >
                {resource.name}
              </span>
            </Styles.MediaResource>
          ) : null}
        </Styles.SelectableResource>
      </Styles.ResourceListItem>
    </ToolTip>
  );
};

export default ResourceItem;
